var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserGroupEditModel, UserGroupFeaturesModel, UserGroupMemberChangeModel, UserGroupModel, UserGroupsClient } from "@/app/api/battery-portal-api";
import RouteNames from "@/app/router/routes";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@/common/utils/notifier";
import { Component, Vue } from "vue-facing-decorator";
const userGroupsClient = new UserGroupsClient(window.apiUrl);
let UserGroupVue = class UserGroupVue extends Vue {
    constructor() {
        super(...arguments);
        this.userGroupId = 0;
        this.working = false;
        this.loaded = false;
        this.submitted = false;
        this.group = new UserGroupModel({ userGroupId: 0, name: "", featureNames: [], members: [] });
        this.features = [];
        this.enabledFeatures = [];
        this.eligibleUsers = [];
        this.selectedUser = null;
    }
    created() {
        this.userGroupId = parseInt(this.$route.params.id) || 0;
        this.load();
    }
    ;
    load() {
        if (this.isNew) {
            this.loaded = true;
            return;
        }
        this.working = true;
        Promise.all([userGroupsClient.get(this.userGroupId), userGroupsClient.getFeatures(), userGroupsClient.getEligibleUsers(undefined)])
            .then(([group, features, eligibleUsers]) => {
            this.group = group;
            this.features = features || [];
            this.eligibleUsers = eligibleUsers || [];
            this.enabledFeatures = [...(group.featureNames || [])];
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    ;
    save() {
        this.submitted = true;
        if (this.working || this.nameMissing)
            return;
        this.working = true;
        const model = new UserGroupEditModel({
            userGroupId: this.userGroupId,
            name: this.group.name,
            description: this.group.description
        });
        // Save covers the whole page: the name and description, then the feature switches.
        const request = this.isNew
            ? userGroupsClient.create(model)
            : userGroupsClient.update(model)
                .then(() => userGroupsClient.setFeatures(new UserGroupFeaturesModel({ userGroupId: this.userGroupId, featureNames: this.enabledFeatures })))
                .then(() => {
                this.group.featureNames = [...this.enabledFeatures];
                return this.userGroupId;
            });
        request
            .then((id) => {
            Notifier.onOk(`User group '${this.group.name}' has been saved.`);
            if (this.isNew) {
                // Features and members are managed once the group exists.
                this.$router.replace({ name: RouteNames.UserGroup, params: { id: id.toString() } })
                    .then(() => {
                    this.userGroupId = id;
                    this.load();
                });
            }
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    addSelectedMember() {
        if (this.working || !this.selectedUser)
            return;
        this.working = true;
        const user = this.selectedUser.user;
        userGroupsClient
            .addMember(new UserGroupMemberChangeModel({ userGroupId: this.userGroupId, userId: user.userId }))
            .then(() => {
            this.group.members = [...(this.group.members || []), user];
            this.selectedUser = null;
            Notifier.onOk(`${user.fullName} has been added.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    removeMember(member) {
        if (this.working)
            return;
        this.working = true;
        userGroupsClient
            .removeMember(new UserGroupMemberChangeModel({ userGroupId: this.userGroupId, userId: member.userId }))
            .then(() => {
            this.group.members = (this.group.members || []).filter(m => m.userId !== member.userId);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    goBack() {
        this.$router.push({ name: RouteNames.UserGroups });
    }
    ;
    isMember(user) {
        return (this.group.members || []).some(m => m.userId === user.userId);
    }
    ;
    companiesText(user) {
        if (user.allCompanies)
            return "All companies";
        return user.companyNames && user.companyNames.length ? user.companyNames.join(", ") : "None";
    }
    ;
    /** Eligible users who are not already members, searchable by name, user name, email and company. */
    get userOptions() {
        return this.eligibleUsers
            .filter(user => !this.isMember(user))
            .map(user => ({
            userId: user.userId,
            text: [user.fullName, user.userName, user.emailAddress, this.companiesText(user)].filter(part => part).join(" - "),
            user
        }));
    }
    ;
    get isNew() {
        return !this.userGroupId;
    }
    ;
    get nameMissing() {
        return this.submitted && !(this.group.name || "").trim();
    }
    ;
    get pageTitle() {
        return this.isNew ? "New User Group" : (this.group.name || "User Group");
    }
    ;
};
UserGroupVue = __decorate([
    Component({
        name: "UserGroupVue"
    })
], UserGroupVue);
export default UserGroupVue;
